import { render } from "./system-error.vue?vue&type=template&id=0898ebf5"
import script from "./system-error.vue?vue&type=script&lang=js"
export * from "./system-error.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./system-error.vue?vue&type=style&index=0&id=0898ebf5&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__